<template>
  <div
    class="flex flex-direction justify-center align-center login-container min-body-height"
  >
    <el-card
      :class="
        (UI.isMobile ? 'full-item' : 'margin-bottom-100') +
          ' ' +
          (UI.clientHeight < 800 ? 'scroll-y' : '')
      "
    >
      <div slot="header" class="clearfix">
        <span v-if="User.user.role == $roleConsts.ORG.value">
          {{
            User.organization_info.organization ? '修改单位认证' : '单位认证'
          }}
        </span>
        <span v-else>
          {{
            User.organization_info.organization
              ? '修改单位认证'
              : '单位认证(可选)'
          }}
        </span>
      </div>
      <Organization
        :class="UI.isMobile ? 'mobile-login-box' : 'login-box'"
      ></Organization>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Organization from './organization.vue';

export default {
  components: {
    Organization,
  },

  computed: {
    ...mapState(['UI', 'User']),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/organizationApprove/index.vue